<template>
	<div class="missin">
		<navbar></navbar>

		<section class="content">
			<md-card>
				<md-card-content>
					Sajnos a keresett oldal nem található
				</md-card-content>
			</md-card>
		</section>

	</div>
</template>

<script>
	import Navbar from './Navbar'

	export default {
		components: {
			Navbar
		}
	}
</script>

<style scoped>
.content{
	margin: 16px;
}
</style>



// WEBPACK FOOTER //
// MissingView.vue?414215c7